import React from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import AppTablaEmpleadosActivos from "src/components/estadisticas/app-tabla-empleados-activos";
import { LoadingButton } from "@material-ui/lab";

const ModalDistribucionEmpleados = ({
  isOpen,
  setOpen,
  title,
  cargandoEmpleados,
  empleados,
}) => {
  const handleClose = () => {
    setOpen(false);
  };
  return (
    <Dialog
      open={isOpen}
      onClose={handleClose}
      aria-labelledby="dialog-modal-estadisticas-facturacion"
      id="dialog-modal-estadisticas-facturacion"
      fullWidth
      maxWidth="xl"
    >
      <DialogTitle>Distribución de Empleados</DialogTitle>
      <DialogContent>
        <AppTablaEmpleadosActivos
          title="Estadísticas empleados"
          subheader="Se pueden revisar las estadísticas de tareas especiales de los empleados"
          rows={!cargandoEmpleados ? empleados : []}
          loading={cargandoEmpleados}
        />
      </DialogContent>
      <DialogActions>
        <LoadingButton onClick={handleClose} color="error">
          Cerrar
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};

export default ModalDistribucionEmpleados;
